module.exports = __webpack_public_path__ + "img/qxb-logo.0e51766a.png";